<template>
  <div>
    <Modal  v-model="isShow" :mask-closable="false" @on-ok="ok"
            :loading="loading" @on-cancel="cancel"
            :class-name="z100000"
            width="700"
            :class="{'mask':mask}"
    >
      <h3 slot="header" class="modal-header">提交解约申请</h3>
      <div style="position: relative">
        <span class="name">解约类型:</span>
        <Select class="width200" v-model="surType" @on-change="changeType">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in surrenderTypeEnums" :value="item.value" :key="'keyA'+index">{{item.text}}
          </Option>
        </Select>
      </div>
      <div style="margin: 20px 0 30px 0;position: relative">
        <span class="name">预计退租日:</span>
        <DatePicker class="width200" v-model="surExpectDate" :options="dateOptions" ></DatePicker>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {toUnRentApply, submitUnRentApply} from "../../../../api/contractList";
  import {formatDateTime} from "../../../../utils/format";

  export default {
    name: "ReleaseApply",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      contractFid: {
        type: Array,
        default: null
      },
      mask:{
        type:Boolean,
        default:false
      }
    },
    watch: {
      n() {
        //+ 清理数据
        this.cleanData()
        this.toUnRentApply()
        this.isShow = true
      }
    },
    data() {
      return {
        z100000:'z100000',
        loading: true,
        isShow: false,
        surrenderTypeEnums: [],
        conEndDate: 0,
        conStartSixDate: 0,
        currentTimestamp: 0,
        surExpectDate: '',
        surType: '',
        conEndDateOneDate:'',
        conStartDateOneDate:'',
        conOverDate:''

      }
    },
    computed: {

      dateOptions() {

        // NORMAL(0, "正常退租"),
        //   ABNORMAL(1, "非退"),
        //   ONE_SIDED(2, "单方面解约"),
        //   THREE_DAYS_NOT_SATISFIED(3, "三天不满意"),
        //   EXCHANGE_RENT(4, "换租"),
        //   SUBLET(5, "转租"),
        //   NO_RESPONS(6, "无责退"),
        //   COMPANY_DEFAULT(7, "公司违约"),
        //   OVERDUE(8, "逾期解约"),
        //   CLEAR_BACK(9, "清退"),
        //   ONE_SIDED_PRE_CONSTARTDATE(10, "单方面解约(起租日前)");

        let start = this.currentTimestamp, end=null
        if([1,2,4,5,6,7,9].indexOf(this.surType)!==-1){
          end = this.conEndDate;
        }
        if(this.surType===0){
          // end=new Date(Number(this.conEndDateOneDate))
          end=this.conEndDateOneDate

        }
        if(this.surType===3){
          end=this.conStartSixDate;
        }
        if(this.surType===10){
          // end=new Date(Number(this.conStartDateOneDate))
          end=this.conStartDateOneDate
        }
        if(this.surType===8){
          end=this.conOverDate
        }

        return {
          disabledDate(date) {
            if(end){
              return date && (date.valueOf()<(start-86400000)  ||  date.valueOf()>end)
            }
            else {
              return date.valueOf()<(start-86400000)
            }
          },
          // start:start,
        }
      }
    },
    methods: {
      cleanData(){
        this.surrenderTypeEnums=[]
        this.conEndDate= 0
        this.conStartSixDate=0
        this.currentTimestamp=0
        this.surExpectDate=''
        this.surType=''
      },
      changeType(){
        this.surExpectDate=''
      },
      toUnRentApply() {
        if(!this.contractFid){
          return
        }
        var params = {
          contractFids: this.contractFid.join(',')
        }
        toUnRentApply(params).then(res=>{
          if(!res.data){
          return
        }
        this.surrenderTypeEnums=res.data.surrenderTypeEnums
        this.currentTimestamp=res.currentTimestamp
        this.conEndDate=res.data.conEndDate
        this.conStartSixDate=res.data.conStartSixDate
        this.conEndDateOneDate=res.data.conEndDateOneDate
        this.conStartDateOneDate=res.data.conStartDateOneDate
        this.conOverDate=res.data.conOverDate

      }).catch(error=>{
          this.isShow=false
        })
      },
      ok() {
        if((!this.surType&&this.surType!==0) || !this.surExpectDate){
          this.$Message.info('请选择解约类型或预计退租日')
          this.changeLoading()
          return
        }
        let params = {
          contractFids: this.contractFid.join(','),
          surExpectDate: formatDateTime(this.surExpectDate,false),
          surType: this.surType
        }
        submitUnRentApply(params).then(res => {
          //增加提示不关闭窗口
          if (res.data.errorCode == 1) {
            this.$Message.error(res.data.errorMsg);
            this.changeLoading();
            return;
          }
          this.$Message.success("解约申请成功")
          this.$emit('done')
          this.isShow=false
        }).catch(error=>{
          this.isShow=false
        })
      },
      cancel() {
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
    }
  }
</script>

<style scoped>
  .name {
    display: inline-block;
    width: 200px;
    text-align: right;
    margin-right: 15px;
  }

  .width200 {
    width: 200px;
  }

</style>
